import { PlayIcon } from './compositeEventIcons';
import type { CompositeGroupingMode } from './compositeEventLayout';

type Props = {
  eventCount: number;
  durationSec: number;
  mode: CompositeGroupingMode;
  onModeChange: (mode: CompositeGroupingMode) => void;
  t: (key: string, values?: Record<string, string | number>) => string;
};

export default function CompositeEventTimelineControls({
  eventCount,
  durationSec,
  mode,
  onModeChange,
  t,
}: Props) {
  const modeButtonClass = (active: boolean) =>
    `cursor-pointer whitespace-nowrap rounded-[4px] px-3 py-1 text-xs font-medium transition-colors ${
      active
        ? 'bg-[#6366f1] text-white'
        : 'bg-[#dadfe9] text-[#696c76] hover:bg-[#c9cfdb] hover:text-[#373747]'
    }`;

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 px-1">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="text-sm font-medium text-[#696c76]">
          {t('{{count}}개 이벤트 ({{start}}s - {{end}}s)', {
            count: eventCount,
            start: 0,
            end: durationSec,
          })}
        </span>
        {/* 막대가 재생 버튼이라는 걸 콘솔 화면만으로는 알기 어려워 안내를 붙인다 */}
        <span className="inline-flex items-center gap-1 rounded-full bg-[rgba(99,102,241,0.12)] px-2 py-0.5 text-xs font-semibold text-[#4338ca]">
          <PlayIcon className="h-3 w-3 shrink-0" />
          {t('막대를 눌러 감지된 소리를 들어보세요')}
        </span>
      </div>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => onModeChange('label')}
          aria-pressed={mode === 'label'}
          className={modeButtonClass(mode === 'label')}
        >
          {t('이벤트 종류')}
        </button>
        <button
          type="button"
          onClick={() => onModeChange('mic')}
          aria-pressed={mode === 'mic'}
          className={modeButtonClass(mode === 'mic')}
        >
          {t('마이크')}
        </button>
      </div>
    </div>
  );
}
